import type { AppliedPromoState } from '@/types'

/**
 * F-MKT-N2 — label for the bill-discount row (till panel, initial bill, final
 * receipt) when an ITEM-ONLY promo code is applied: "Promo DRINKS20 ·
 * Beverages & Desserts". Null for whole-bill codes, so their receipts stay
 * exactly as they were.
 */
export function scopedPromoDiscountLabel(state: AppliedPromoState | null | undefined): string | null {
  if (!state?.applied || !state.applies_to) return null
  const code = state.code ? `Promo ${state.code}` : 'Promo'
  return `${code} · ${state.applies_to}`
}
